<template>
    <b-modal
        id="lesson-update-modal"
        v-model="modal"
        :title="$t('lesson.edit_lesson')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal update-lesson-modal"
        size="xl">
        <b-form-group
            class="lesson-title"
            label-for="lesson-title-input"
            :label="$t('common.title')">
            <b-form-input
                id="lesson-title-input"
                v-model="title"
                :placeholder="$t('common.title')">
            </b-form-input>
        </b-form-group>
        <div class="preparation">
            <b-form-group
                :label="$t('lesson.question_explanation')">
                <ckeditor
                    id="preparation-input"
                    v-model="preparation"
                    :editor="editor"
                    :config="editorConfig">
                </ckeditor>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-update-lesson-modal-component',
    data() {
        return {
            modal: false,
            title: '',
            lesson: null,
            preparation: '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'bulletedList',
                        'numberedList',
                        'blockQuote',
                        '|',
                        'undo',
                        'redo',
                        'link',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
        };
    },
    methods: {
        show(lesson) {
            this.lesson = lesson;
            this.title = lesson.title;
            this.preparation = lesson.preparation;
            this.modal = true;
        },
        save() {
            this.alert.saving();
            let data = {
                title: this.title,
                preparation: this.preparation,
            };

            this.axios.post(this.routes.lessonManualLessonUpdate(this.lesson.id), data).then(
                (response) => {
                    this.$emit('lesson-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError;
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
    .preparation ::v-deep{
        .ck.ck-editor {
            .ck.ck-editor__main > div.ck-editor__editable {
                height: 250px;
            }
        }
    }
</style>
